var _excluded = ["containerStyles", "onSearch", "onClear", "placeholder", "searchText", "showClear"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Search from '@mui/icons-material/Search';
import { Button } from '@mui/material';
import { Clear } from '@mui/icons-material';
var PREFIX = 'BrandSearchInput';
var classes = {
  underline: "".concat(PREFIX, "-underline"),
  root: "".concat(PREFIX, "-root"),
  disabled: "".concat(PREFIX, "-disabled")
};
var Root = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty(_defineProperty(_defineProperty({}, "& .".concat(classes.underline), {
    '&&&:before': {
      borderBottom: "1px solid ".concat(theme.palette.font.primary)
    }
  }), "& .".concat(classes.root), {
    color: theme.palette.font.primary,
    '& fieldset': {
      borderColor: theme.palette.font.primary
    },
    '&: hover fieldset': {
      borderColor: theme.palette.font.primary,
      border: '2px solid'
    }
  }), '& .BrandSearchInput-disabled', {
    WebkitTextFillColor: "".concat(theme.palette.font.primary, " !important"),
    '& fieldset': {
      borderColor: "".concat(theme.palette.font.primary, " !important"),
      opacity: 0.3
    },
    'div > svg': {
      opacity: 0.3
    }
  });
});
var BrandSearchInput = function BrandSearchInput(_ref3) {
  var containerStyles = _ref3.containerStyles,
    onSearch = _ref3.onSearch,
    onClear = _ref3.onClear,
    placeholder = _ref3.placeholder,
    searchText = _ref3.searchText,
    _ref3$showClear = _ref3.showClear,
    showClear = _ref3$showClear === void 0 ? false : _ref3$showClear,
    props = _objectWithoutProperties(_ref3, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Root, {
    style: containerStyles
  }, /*#__PURE__*/React.createElement(TextField, _extends({}, props, {
    color: "primary",
    size: "small",
    variant: "outlined",
    value: searchText,
    onChange: onSearch,
    placeholder: placeholder || t('search'),
    InputProps: {
      classes: classes,
      startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React.createElement(Search, {
        color: "primary"
      })),
      endAdornment: /*#__PURE__*/React.createElement(Button, {
        disableRipple: true,
        size: "small",
        variant: "text",
        disabled: props.disabled || !showClear,
        sx: {
          margin: 0,
          padding: 0,
          minWidth: 'min-content',
          opacity: showClear ? 1 : 0
        },
        onClick: function onClick() {
          if (onClear) {
            onClear();
          }
        }
      }, /*#__PURE__*/React.createElement(Clear, null))
    }
  })));
};
BrandSearchInput.propTypes = {
  containerStyles: PropTypes.object,
  placeholder: PropTypes.string,
  searchText: PropTypes.string,
  showClear: PropTypes.bool
};
export default BrandSearchInput;